import { useEffect, useState } from 'react';

import { FIREPLACE, CANVAS } from '../config/positions';

import { useHolidayStore } from '@/store/useHolidayStore';

interface FireParticle {
  id: number;
  x: number;
  y: number;
  delay: number;
  size: number;
}

export function FireBurst() {
  const { gifts } = useHolidayStore();
  const [particles, setParticles] = useState<FireParticle[]>([]);
  const [showBurst, setShowBurst] = useState(false);

  // Watch for any gift that starts burning
  const burningGift = gifts.find(g => g.burning);

  useEffect(() => {
    if (burningGift) {
      // Show burst effect
      setShowBurst(true);

      // Generate random fire particles
      const newParticles: FireParticle[] = [];
      for (let i = 0; i < 8; i++) {
        newParticles.push({
          id: i,
          x: (Math.random() - 0.5) * 80,
          y: (Math.random() - 0.5) * 40,
          delay: Math.random() * 0.1,
          size: 16 + Math.random() * 24,
        });
      }
      setParticles(newParticles);

      // Hide after animation
      const timer = setTimeout(() => {
        setShowBurst(false);
        setParticles([]);
      }, 600);

      return () => clearTimeout(timer);
    }
  }, [burningGift?.id]);

  if (!showBurst) return null;

  // Position at center of fireplace
  const centerX = ((FIREPLACE.x + FIREPLACE.width / 2) / CANVAS.width) * 100;
  const centerY = ((FIREPLACE.y + FIREPLACE.height / 2) / CANVAS.height) * 100;

  return (
    <div
      className="absolute pointer-events-none"
      style={{
        left: `${centerX}%`,
        top: `${centerY}%`,
        transform: 'translate(-50%, -50%)',
        zIndex: 99,
      }}
    >
      {/* Central fire burst */}
      <div
        className="absolute animate-fire-burst"
        style={{
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
          width: '100px',
          height: '100px',
          background: 'radial-gradient(circle, rgba(255,200,50,0.9) 0%, rgba(255,100,0,0.7) 40%, rgba(255,50,0,0) 70%)',
          borderRadius: '50%',
          filter: 'blur(8px)',
        }}
      />

      {/* Fire particles */}
      {particles.map((particle) => (
        <div
          key={particle.id}
          className="absolute animate-fire-particle"
          style={{
            left: `calc(50% + ${particle.x}px)`,
            top: `calc(50% + ${particle.y}px)`,
            width: `${particle.size}px`,
            height: `${particle.size}px`,
            background: 'radial-gradient(circle, rgba(255,220,100,1) 0%, rgba(255,120,0,0.8) 50%, transparent 70%)',
            borderRadius: '50%',
            filter: 'blur(3px)',
            animationDelay: `${particle.delay}s`,
          }}
        />
      ))}
    </div>
  );
}
